import React, {useState} from 'react';
import {useNavigate} from 'react-router';
import {cn, RsnButton, RsnDialog, RsnTextButton} from '~/library/ui-kit';
import doc from '../icons/doc.svg';
import heartIcon from '../icons/heart-fill.svg';
import styles from './CloseAccountModal.module.scss';

export const CloseAccountModal = ({navigationReplace}: {navigationReplace?: boolean}) => {
    const navigate = useNavigate();
    const [step, setStep] = useState(0);

    const imageSrc = [heartIcon, doc];
    const headerText = [
        {
            firstLine: 'Hold on a second!',
            secondLine: 'Are you sure?',
        },
        {
            firstLine: 'We have to store your',
            secondLine: 'data by the law',
        },
    ];
    const mainText = [
        'Your account is free of charge. Closing account is\xA0irreversible. Continue if you are sure of your decision.\n ',
        'The data will be stored for 5 years due to\xA0regulations. Please, assure that you have withdrawn all of your assets, otherwise they will\xA0be\xA0lost.',
    ];

    const handleSteps = () => {
        if (!step) {
            setStep(1);
        } else {
            navigate('/profile/account_closure', {replace: navigationReplace});
        }
    };

    return (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader
                icon={{
                    element: (
                        <div className={cn(styles.stepIconContainer, step === 0 ? styles.first : styles.second)}>
                            <img src={imageSrc[step]} className={styles.stepIcon} alt='close account' />
                        </div>
                    ),
                }}
            >
                {headerText[step].firstLine}
                <br />
                {headerText[step].secondLine}
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>
                <div className='whitespace-break-spaces'>{mainText[step]}</div>
                <RsnTextButton.Block className='fv-text-l-regular' onClick={handleSteps}>
                    {step ? 'Continue account closure' : 'Close my account'}
                </RsnTextButton.Block>
            </RsnDialog.Body>
            <RsnDialog.Footer column>
                <RsnButton.Alike as={RsnDialog.CloseTrigger} intent={'primary'}>
                    I&apos;m staying
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
};
